import { ConditionMode, ConditionUnit, getUnitTranslationId } from '@synergy/models';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { ReactElement } from 'react';

interface ModeFormattedNumberProps {
    mode: ConditionMode;
    value: number;
    unit?: ConditionUnit;
    currency?: string;
}

export const ModeFormattedNumber = (props: ModeFormattedNumberProps): ReactElement => {
    const { unit, mode, value, currency } = props;
    const intl = useIntl();

    if (mode === ConditionMode.Amount) {
        return (
            <FormattedMessage
                id="app.common.formattedUnitNumber"
                values={{
                    value: intl.formatNumber(value, { maximumFractionDigits: 2 }),
                    unit: intl.formatMessage({
                        id: getUnitTranslationId(unit),
                    }),
                }}
            />
        );
    }

    return (
        <FormattedNumber
            value={value}
            currency={currency}
            style="currency"
            minimumFractionDigits={2}
            maximumFractionDigits={2}
        />
    );
};
